module.exports = __webpack_public_path__ + "static/img/item-7-2-big.086040e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/innovation/item-7-2-big.jpg
// module id = YiVA
// module chunks = 2